import { Button, Col, Row } from "antd";
import { PlanType } from "../../types/planType";
import { useModal } from "../../cro/context/CroModalContext";
import { btnStyle } from "../../cro/styles/buttonStyles";
import CroModalCloseBtn from "../../cro/context/CroModalCloseBtn";
import OpenInNew from "../../cro/icons/OpenInNew.svg";
import { useTranslation } from "react-i18next";

interface PlanDocumentProps {
  plan: PlanType;
}
const PlanDocument: React.FC<PlanDocumentProps> = ({ plan }) => {
  const { hideModal } = useModal();
  const { t } = useTranslation("cro");
  return (
    <>
      <div
        style={{
          padding: 16,
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <span
          style={{
            fontSize: 20,
            fontWeight: "bold",
            width: "100%",
            color: "#253F66",
          }}
          className="roboto-regular"
        >
          {t("PLAN DOCUMENTS")}
        </span>
        <CroModalCloseBtn />
      </div>
      <ul style={{ padding: 18 }}>
        {plan.docs.map((doc: any, index: number) => (
          <li key={index} style={{ marginBottom: "10px" }}>
            <img
              src={OpenInNew}
              alt="open in new tab"
              style={{ width: "1.5rem", height: "auto", marginRight: 8 }}
            />
            <a
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "underline",
                color: "#253F66",
                fontWeight: 400,
              }}
            >
              {t(doc.display_name.trim())}
            </a>
          </li>
        ))}
      </ul>
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col span={24}>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: 16,
              gap: 16,
            }}
          >
            <Button style={btnStyle} onClick={() => hideModal()}>
              {t("Close")}
            </Button>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default PlanDocument;
